// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3ZK4B","search":"Settings_search__y-03h","filter":"Settings_filter__2-UR-"};